import * as React from 'react';
import injectStyles from '../jss';
import styles from './SocialLinks.jss';
var SocialLinks = function SocialLinks(_ref) {
  var classes = _ref.classes,
    socialLinks = _ref.socialLinks;
  var renderSocialLink = function renderSocialLink(_ref2, index) {
    var Icon = _ref2.icon,
      url = _ref2.url;
    return React.createElement("a", {
      href: url,
      key: "socialLink_".concat(index),
      target: "_blank",
      className: classes.icon
    }, React.createElement(Icon, {
      className: classes.svgIcon
    }));
  };
  if (!socialLinks || socialLinks.length <= 0) {
    return null;
  }
  return React.createElement("div", {
    className: classes.divided
  }, socialLinks.map(renderSocialLink));
};
SocialLinks.styleRoot = 'SocialLinks';
export default injectStyles(styles)(SocialLinks);